export default function getFormat(datetime: boolean, monthOnly?: boolean) {
  if (monthOnly) {
    return 'MMM YYYY';
  }

  if (datetime) {
    return 'DD/MM/YYYY kk:mm A';
  }

  return 'DD/MM/YYYY';
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/datepicker/config.ts